import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { bootstrap } from './bootstrap';
import './index.css';

// AWS Amplify UI Theme
import '@aws-amplify/ui-react/styles.css';

(async () => {
    // bootstrap() brings up RUM telemetry, installs the global error handlers,
    // and configures Amplify. On failure it renders the appropriate pre-React
    // error UI and returns false, in which case React must not mount.
    const ready = await bootstrap();
    if (!ready) {
        return;
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
})();
